"use strict";
/**
 * Copyright © 2019 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleTextField = void 0;
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
exports.SimpleTextField = (_a) => {
    var { onValueChange, label } = _a, props = __rest(_a, ["onValueChange", "label"]);
    return (react_1.default.createElement(material_1.FormControl, { fullWidth: true, variant: "filled", margin: "dense" },
        react_1.default.createElement(material_1.InputLabel, { htmlFor: "component-filled" }, label),
        react_1.default.createElement(material_1.FilledInput, Object.assign({ placeholder: label, fullWidth: true, onChange: (e) => {
                e.preventDefault();
                if (onValueChange) {
                    onValueChange(e.target.value);
                }
            } }, props))));
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2ltcGxlVGV4dEZpZWxkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvU2ltcGxlVGV4dEZpZWxkLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7Ozs7OztHQU1HOzs7Ozs7Ozs7Ozs7Ozs7OztBQUVILGtEQUEwQjtBQUMxQiw0Q0FLdUI7QUFTVixRQUFBLGVBQWUsR0FBRyxDQUFDLEVBQTRDLEVBQUUsRUFBRTtRQUFoRCxFQUFFLGFBQWEsRUFBRSxLQUFLLE9BQXNCLEVBQWpCLEtBQUssY0FBaEMsMEJBQWtDLENBQUY7SUFDOUQsT0FBTyxDQUNMLDhCQUFDLHNCQUFXLElBQUMsU0FBUyxRQUFDLE9BQU8sRUFBQyxRQUFRLEVBQUMsTUFBTSxFQUFDLE9BQU87UUFDcEQsOEJBQUMscUJBQVUsSUFBQyxPQUFPLEVBQUMsa0JBQWtCLElBQUUsS0FBSyxDQUFjO1FBQzNELDhCQUFDLHNCQUFjLGtCQUNiLFdBQVcsRUFBRSxLQUFLLEVBQ2xCLFNBQVMsUUFDVCxRQUFRLEVBQUUsQ0FBQyxDQUFzQyxFQUFFLEVBQUU7Z0JBQ25ELENBQUMsQ0FBQyxjQUFjLEVBQUUsQ0FBQztnQkFDbkIsSUFBSSxhQUFhLEVBQUU7b0JBQ2pCLGFBQWEsQ0FBQyxDQUFDLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxDQUFDO2lCQUMvQjtZQUNILENBQUMsSUFDRyxLQUFLLEVBQ1QsQ0FDVSxDQUNmLENBQUM7QUFDSixDQUFDLENBQUMifQ==